<template>
  <div class="logo-and-editor-container fly-in-3">
    <div class="logo-and-editor-wrapper">
      <div class="logo-wrapper">
        <div class="logo">
          <a href="https://udn.com/news/index" target="_blank">
            <img src="images/logo/udndotcom_logo.svg" alt="聯合新聞網">
          </a>
        </div>
        <div class="logo"><img src="images/logo/nm_logo.svg" alt="聯合報新媒體中心"></div>
      </div>
      <div class="editor-container">
        <div class="editor-wrapper">
          <div class="editor">統籌製作：謝汶均</div>
          <div class="editor">影像：陳正興</div>
          <div class="editor">設計：蘇士堯</div>
          <div class="editor">網頁製作：楊若榆</div>
          <div class="editor">數位行銷：陳雨暄、劉時均</div>
          <div class="editor">製作單位：聯合報新媒體中心、視覺設計中心</div>
          <div class="editor">監製：聯合報新聞部</div>
        </div>
        <div class="editor-wrapper">
          <div class="editor">
            聯合線上公司 著作權所有 © udn.com All Rights Reserved.
          </div>
        </div>
        <div class="editor-wrapper">
          <div class="editor">
            2019.09.02
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoAndEditor',
};
</script>

<style lang="scss" scoped>
  .logo-and-editor-container {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin: 2% 0 0 0;
    // padding: 5% 0;
    background-color: #f1f1f1;
    .logo-and-editor-wrapper {
      position: relative;
      width: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
      @media only screen and (min-width: 1440px) {
        width: 85%;
      }
    }
    .logo-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 5px;
      .logo {
        position: relative;
        width: 150px;
        a {
          position: relative;
          width: 100%;
        }
        img {
          width: 100%;
          padding: 10px;
        }
      }
    }
    .editor-container {
      position: relative;
      .editor-wrapper {
        position: relative;
        width: 100%;
        border-left: solid 1px #a5a5a5;
        color: #a5a5a5;
        padding-left: 5px;
        @media only screen and (max-width: 1280px) {
          font-size: 14px;
        }
        .editor {
          display: inline-block;
          padding: 0 6px;
        }
      }
    }
  }
</style>

